export enum ButtonTestIds {
	ButtonElementTestId = 'sl-button',
	ButtonLabelElementTestId = 'sl-button-label',
	ButtonIconElementTestId = 'sl-button-icon',
}
